<!-- A widget that shows an animated preview of a ticker message. -->

<template>
  <div
    style="user-select: none"
    :style="{
      'max-width': maxWidth + 'px !important',
    }"
  >
    <v-card
      class="grey"
      style="overflow: hidden; border-radius: 4px"
    >
      <v-card-text style="height: 200px" />
    </v-card>
    <v-card
      dark
      style="
        position: relative;
        top: -34px;
        opacity: 0.7;
        border-radius: 0 0 4px 4px;
      "
    >
      <v-card-title class="white ticker pa-1">
        <q class="animated-ticker black--text">{{ extendedTickerMessage }}</q>
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  computed: {
    maxWidth() {
      const maxOverall = 356;
      const maxAvailable = this.$vuetify.breakpoint.width - 112;
      return Math.min(maxOverall, maxAvailable);
    },
    /**
     * Create a long repeated version of the message that we can
     * animate to preview the actual ticker behaviour.
     */
    extendedTickerMessage() {
      let message = '';
      for (var i = 0; i < 100; i++) {
        message += this.message + '   +++   ';
      }
      return message;
    },
  },
};
</script>

<style scoped>
.ticker {
  font-size: 1.25em;
  font-style: italic;
  font-weight: bold;
  letter-spacing: -0.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.animated-ticker {
  white-space: nowrap;
  animation: ticker-animation 80s linear infinite;
}

@keyframes ticker-animation {
  to {
    margin-left: -200vw;
  }
}

@media (max-width: 599px) {
  @keyframes ticker-animation {
    to {
      margin-left: -1000vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TickerPreview.vue